import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { Toast, Toasts } from '../models/types/Toast.type';
import { ToastType } from '../models/enums/Toast.enum';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private readonly _DEELAY: number = 10000;

  private readonly mocked: Toasts = [
    {
      message: 'Ciao',
      type: ToastType.Success
    },
    {
      message: 'Ciao',
      type: ToastType.Info
    },
    {
      message: 'Ciao',
      type: ToastType.Error
    },
  ]

  private _toasts: WritableSignal<Toasts> = signal([]);
  public toasts: Signal<Toasts> = computed(() => this._toasts());

  constructor(private readonly translateService: TranslateService) { }

  addToast(toast: Toast) {
    toast.message = this.translateService.instant(toast.message)
    let toasts = this.toasts();
    toasts.splice(0, 0, toast);
    this._toasts.set(toasts);
    setTimeout(() => {
      this.removeLastToast();
    }, this._DEELAY)
  }

  removeToast(toast: Toast) {
    let toasts = this.toasts();
    toasts = toasts.filter(t => t !== toast);
    this._toasts.set(toasts);
  }

  removeLastToast() {
    let toasts = this.toasts();
    toasts.pop();
    this._toasts.set(toasts);
  }

  showInfo(message: string) {
    let toast = {
      message,
      type: ToastType.Info
    };
    this.addToast(toast);
  }

  showSuccess(message: string) {
    let toast = {
      message,
      type: ToastType.Success
    };
    this.addToast(toast);
  }

  showError(message?: string) {
    let toast = {
      message: message ?? "An error occurred",
      type: ToastType.Error
    };
    this.addToast(toast);
  }
}
